<div
  class="modal-dialog modal-dialog-centered"
  style="max-width: none !important"
>
  <div class="modal-content">
    <div class="modal-body">
      <h5 class="text-center mb-4">{{ 'directives.modal.labelsTitle' | translate }}</h5>
      <table
        class="table table-bordered"
        *ngIf="etiquetas && etiquetas.length !== 0"
      >
        <thead>
          <tr>
            <th>{{ 'directives.label' | translate }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let etiqueta of etiquetas">
            <td>{{ etiqueta }}</td>
          </tr>
        </tbody>
      </table>
      <div *ngIf="!etiquetas || etiquetas.length === 0">
        {{ 'directives.modal.noLabels' | translate }}
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-sm btn-primary" (click)="cancel()">
        {{ 'accept' | translate }}
      </button>
    </div>
  </div>
</div>
